import { SvgIcon, SvgIconProps } from '@mui/material';

const PrivilegeEscalationIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <g>
      <path d="M21.3333 14C24.5562 14 27.1666 11.315 27.1666 8C27.1666 4.685 24.5562 2 21.3333 2C18.1104 2 15.5 4.685 15.5 8C15.5 11.315 18.1104 14 21.3333 14ZM21.3333 17C17.4395 17 9.66663 19.01 9.66663 23V26H33V23C33 19.01 25.227 17 21.3333 17Z" />
      <path d="M0.844926 4.93029L0.777155 5L0.844926 5.06971L2.13008 6.39158L2.20163 6.46518L2.27334 6.39173L4.28017 4.3362V15.5V15.6H4.38017H6.20308H6.30308V15.5V4.33768L8.30051 6.40081L8.37221 6.47486L8.44406 6.40096L9.73833 5.06971L9.8061 5L9.73833 4.93029L5.36333 0.430292L5.29163 0.356544L5.21993 0.430292L0.844926 4.93029Z" />
    </g>
  </SvgIcon>
);

PrivilegeEscalationIcon.defaultProps = { viewBox: '0 0 33 26' };

export default PrivilegeEscalationIcon;
